// API service for financial reports
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

class FinancialReportsService {
  // Get daily financial report for a specific month
  static async getDailyFinancialReport(token, year, month, doctorId = 'all') {
    try {
      let url = `${API_BASE_URL}/reports/financial/daily?year=${year}&month=${month}`;
      if (doctorId && doctorId !== 'all') {
        url += `&doctorId=${doctorId}`;
      }

      console.debug('[FinancialReportsService] daily report request', { url });
      
      const response = await fetch(url, {
        method: 'GET',
        cache: 'no-store',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.debug('[FinancialReportsService] daily report response', {
        ok: response.ok,
        status: response.status,
        summary: data?.data?.summary
      });
      return data.data;
    } catch (error) {
      console.error('Error fetching daily financial report:', error);
      throw error;
    }
  }

  // Get monthly financial report for a specific year
  static async getMonthlyFinancialReport(token, year, doctorId = 'all') {
    try {
      let url = `${API_BASE_URL}/reports/financial/monthly?year=${year}`;
      if (doctorId && doctorId !== 'all') {
        url += `&doctorId=${doctorId}`;
      }

      console.debug('[FinancialReportsService] monthly report request', { url });

      const response = await fetch(url, {
        method: 'GET',
        cache: 'no-store',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.debug('[FinancialReportsService] monthly report response', {
        ok: response.ok,
        status: response.status,
        summary: data?.data?.summary
      });
      return data.data;
    } catch (error) {
      console.error('Error fetching monthly financial report:', error);
      throw error;
    }
  }

  // Get yearly financial report
  static async getYearlyFinancialReport(token, startYear = null, endYear = null) {
    try {
      let url = `${API_BASE_URL}/reports/financial/yearly`;
      const params = new URLSearchParams();
      
      if (startYear) params.append('startYear', startYear);
      if (endYear) params.append('endYear', endYear);
      
      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      const response = await fetch(url, {
        method: 'GET',
        cache: 'no-store',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching yearly financial report:', error);
      throw error;
    }
  }

  // Export payments for a specific month
  static async getMonthlyPaymentsExport(token, year, month, doctorId = 'all') {
    try {
      let url = `${API_BASE_URL}/reports/financial/payments?year=${year}&month=${month}`;
      if (doctorId && doctorId !== 'all') {
        url += `&doctorId=${doctorId}`;
      }

      const response = await fetch(url, {
        method: 'GET',
        cache: 'no-store',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache'
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Error fetching payments export:', error);
      throw error;
    }
  }
}

export default FinancialReportsService;
